import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

const setRaceSummaryNoHistory = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium};
            background: ${theme.star.raceSummary.bgColorQuaternary};
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css``;
};

interface RaceSummaryNoHistoryPropsType {
    variant: DefaultComponentVariantType | null;
}

export const RaceSummaryNoHistory = withConfig(theme => styled('div', { label: 'RaceSummaryNoHistory' })<RaceSummaryNoHistoryPropsType>`
    ${({ variant }): SerializedStyles=> setRaceSummaryNoHistory(variant, theme)};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3;
`);


interface RaceSummaryPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryListWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
        `;
    }
    return css``;
};

export const RaceSummaryListWrapper = withConfig(theme => styled(`ul`, { label: 'RaceSummaryListWrapper' })<RaceSummaryPropsType>`
    ${({ variant }): SerializedStyles=> setRaceSummaryListWrapper(variant, theme)};
`);

const setRaceRowsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

interface RaceResultsPropsType {
    variant: DefaultComponentVariantType | null;
}

export const RaceRowsWrapper = withConfig(theme => styled('div', { label: 'RaceRowsWrapper' })<RaceResultsPropsType>`
    ${({ variant }): SerializedStyles=> setRaceRowsWrapper(variant, theme)};
`);
